module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m1-db33afcf2012fde9555f8e1bc48a38b7.png";